import { render, staticRenderFns } from "./InventoryDaysTables.vue?vue&type=template&id=55fabbfe"
import script from "./InventoryDaysTables.vue?vue&type=script&lang=js"
export * from "./InventoryDaysTables.vue?vue&type=script&lang=js"
import style0 from "./InventoryDaysTables.vue?vue&type=style&index=0&id=55fabbfe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports